import { APIPath } from '../constants';
import { BaseService } from './base';

class Feed {
  getFeedStatus(feedId) {
    return BaseService.get(`${APIPath.feeds}/${feedId}/status`);
  }
}

const FeedService = new Feed();
Object.freeze(FeedService);
export { FeedService };
